import Lista from './components/Lista';
import NumeroInteiro from './components/NumeroInteiro';
import NumeroReal from './components/NumeroReal';
import Texto from './components/Texto';
import ImportacaoTerceiros from './components/ImportacaoTerceiros';
import Booleano from './components/Booleano';
import FundamentoLegal from './components/FundamentoLegal';

const typesComponents = {
  BOOLEANO: Booleano,
  NUMERO_INTEIRO: NumeroInteiro,
  NUMERO_REAL: NumeroReal,
  TEXTO: Texto,
  LISTA: Lista,
  CPF_CNPJ: Lista,
  IMPORTACAO_TERCEIROS: ImportacaoTerceiros,
  VALOR_MONETARIO: NumeroReal,
  FUNDAMENTO_LEGAL: FundamentoLegal,
}


/*
  Os tipos apresentados na documentação são :

    [
      BOOLEANO,
      DATA,
      DATA_HORA,
      NUMERO_INTEIRO,            OK
      NUMERO_REAL,               OK
      TEXTO,
      LISTA,                     OK
      CRONOGRAMA,
      RUC,
      OPERADOR_ESTRANGEIRO,
      FABRICANTE,
      IMPORTACAO_TERCEIROS,      OK +/-
      VALOR_COM_UNIDADE_MEDIDA,
      VALOR_MONETARIO,           OK
      FUNDAMENTO_LEGAL,
      ATRIBUTO_COMPOSTO,
      VALOR_LPCO_VINCULADO,
      CHAVE_NFE,
      CPF_CNPJ,                  OK
      CNPJ,
      LISTA_TABX_FILTRO
    ]

*/

export default typesComponents
